import React from "react";

import { componentNanoid } from "../../utils/componentNanoid";
import formatSearchResults from "../SearchContents/formatSearchResults";
import { composeCards } from "./composeCards";
import { useSearchResults } from "../../context/DataContext";
import { getCollectionResultsClass } from "../../search";
import { joinClassNames } from "../../utils/joinClassNames";

import Card from "./Card";
import { ResultColumn } from "../SearchContents/SearchResults";

import styles from "./SearchResultCardList.module.css";

export type SearchResultCardListProps = {
    itemDefs: ResultColumn[];
};

export const SearchResultCardList = ({
    itemDefs,
}: SearchResultCardListProps) => {
    const {
        config: { collection },
        results,
        resultsSummary: summary,
    } = useSearchResults();
    const resultsClass = getCollectionResultsClass(collection);
    const rawItems = formatSearchResults(results, itemDefs);
    const items = composeCards(itemDefs, rawItems);
    const maybeCards = items.length ? (
        <ol
            start={summary.currStart}
            className={joinClassNames([
                styles.resultsCards,
                ...(resultsClass ? [styles[resultsClass]] : []),
            ])}
        >
            {items.map((parts) => (
                <Card
                    parts={parts}
                    resultsClass={resultsClass}
                    key={`card-${componentNanoid()}`}
                />
            ))}
        </ol>
    ) : null;
    return maybeCards;
};

export default SearchResultCardList;
